// extracted by mini-css-extract-plugin
export var bottomWave = "U+Z8o";
export var imageContainer = "ZpuZ4";
export var root = "_4s2G6";